module Bookhus {

    export class LocalizedValues {
        culture: string;
        uge: string;
        datePattern: string;

        constructor(culture: string) {
            this.culture = culture;
            this.getLocalizedValues();
        }

        private getLocalizedValues() {
            this.uge = $.datepicker.regional[this.culture].weekHeader;
            this.idag = $.datepicker.regional[this.culture].currentText;
            this.datePattern = $.datepicker.regional[this.culture].dateFormat;
            this.dayNamesMin = $.datepicker.regional[this.culture].dayNamesMin;
            this.dayNames = $.datepicker.regional[this.culture].dayNames;
            this.monthNames = $.datepicker.regional[this.culture].monthNames;

            if (this.text[this.culture] === undefined) {
                this.culture = "da";
            }
            this.book = this.text[this.culture].book;
            this.moreInfo = this.text[this.culture].moreInfo;
            this.pickMonth = this.text[this.culture].pickMonth;

            this.handle = this.text[this.culture].handle;
            this.open = this.text[this.culture].open;
            this.externalHouses = this.text[this.culture].externalHouses;
        }

        idag: string;
        dayNames: string[];
        dayNamesMin: string[];
        monthNames: string[];

        book: string;
        moreInfo: string;
        pickMonth: string;

        handle: string;
        open: string;
        externalHouses: string;

        private text = {
            da: {
                book: 'Book',
                moreInfo: 'Mere info',
                pickMonth: 'Vælg måned',
                handle: 'Håndter',
                open: 'Åben',
                externalHouses: 'Eksterne ferieboliger'
            },
            "en-GB": {
                book: 'Book',
                moreInfo: 'More info',
                pickMonth: 'Select month',
                handle: 'Handle',
                open: 'Open',
                externalHouses: 'External holiday homes'
            },
            no: {
                book: 'Bestill',
                moreInfo: 'Mer informasjon',
                pickMonth: 'Velg måned',
                handle: 'Åpen',
                open: 'Åpen',
                externalHouses: 'Eksterne fritidsboliger'
            },
            sv: {
                book: 'Boka',
                moreInfo: 'Mer info',
                pickMonth: 'Välj månad',
                handle: 'Handle',
                open: 'Öppen',
                externalHouses: 'Externa fritidshus'
            },
            de: {
                book: 'Buchen',
                moreInfo: 'Weitere Infos',
                pickMonth: 'Monat auswählen',
                handle: 'Handle',
                open: 'Offen',
                externalHouses: 'Externe ferienhäuser'
            }
        }


    }

} 